import Vue from 'vue'
import {
  FETCH_WINLOSE_RESULT_REQUEST,
  FETCH_WINLOSE_RESULT_SUCCESS,
  FETCH_WINLOSE_RESULT_ERROR,
  FETCH_GAME_RESULT_REQUEST,
  FETCH_GAME_RESULT_SUCCESS,
  FETCH_GAME_RESULT_ERROR,
} from '../actions/report'
import {
  BASE_URL,
  WINLOSE_RESULT,
  M_POST
} from "../../utils/api"

const state = {
  status: "",
}

const actions = {
  
  [FETCH_WINLOSE_RESULT_REQUEST]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit(FETCH_WINLOSE_RESULT_REQUEST)
      Vue.axios({ url: BASE_URL + WINLOSE_RESULT, data: data, method: M_POST })
        .then(resp => {
          let result = resp.data
          if (result.status.code === 0) {
            commit(FETCH_WINLOSE_RESULT_SUCCESS)
            resolve(result.data)
          } else {
            throw result.status
          }
        })
        .catch(err => {
          commit(FETCH_WINLOSE_RESULT_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [FETCH_WINLOSE_RESULT_REQUEST]: state => {
    state.status = "loading"
  },
  [FETCH_WINLOSE_RESULT_SUCCESS]: state => {
    state.status = "success"
  },
  [FETCH_WINLOSE_RESULT_ERROR]: state => {
    state.status = "error"
  },
  [FETCH_GAME_RESULT_REQUEST]: state => {
    state.status = "loading"
  },
  [FETCH_GAME_RESULT_SUCCESS]: state => {
    state.status = "success"
  },
  [FETCH_GAME_RESULT_ERROR]: state => {
    state.status = "error"
  },
}

export default {
  state,
  actions,
  mutations
}
